import { Colors } from './';
import { textStyles } from './fonts-ppv';

const type = {
  Kanit: 'Kanit-Light',
  KanitLight: 'Kanit-Light',
  KanitBold: 'Kanit-Bold',
  KanitSemiBold: 'Kanit-SemiBold',
  KanitRegular: 'Kanit-Regular',
  KanitMedium: 'Kanit-Medium',
  KanitBlack: 'Kanit-Black',
};

const size = {
  superHeadline: '56pt',
  headline: '32px',
  headline2: '28px',
  header: '26px',
  title: '26px',
  text1: '22px',
  text3: '20px',
  text4: '23px',
  text10: '10px',
  text12: '12px',
  text14: '14px',
  text16: '16px',
  text18: '18px',
  text20: '20px',
  text22: '22px',
  text24: '24px',
  text48: '48px',
  text70: '70px',
  content: '14px',
  mini: '12px'
};
const style = {
  superHeadline: {
    fontFamily: type.Kanit,
    fontSize: size.superHeadline
  },
  headline: {
    fontFamily: type.KanitMedium,
    fontSize: size.headline
  },
  headline2: {
    fontFamily: type.Kanit,
    fontSize: size.headline2
  },
  header: {
    ...textStyles.h2,
    color: Colors.grey800,
  },
  headerFakeBlack: {
    ...textStyles.h3,
    fontSize: size.text20,
    color: Colors.font.primary.fakeBlack
  },
  subheader: {
    fontFamily: type.Kanit,
    fontSize: size.text1,
    color: Colors.font.primary.fakeBlack,
  },
  title: {
    fontFamily: type.Kanit,
    fontSize: size.title,
  },
  text1: {
    fontFamily: type.Kanit,
    fontSize: size.text1
  },
  text2: {
    fontFamily: type.Kanit,
    fontSize: size.text24
  },
  text3: {
    fontFamily: type.Kanit,
    fontSize: size.text3
  },
  textRegularHeader: {
    fontFamily: type.KanitRegular,
    fontSize: size.text16
  },
  textRegularContent: {
    fontFamily: type.KanitRegular,
    fontSize: size.text16
  },
  textMediumContent: {
    fontFamily: type.KanitMedium,
  },
  textRegular3: {
    fontFamily: type.KanitRegular,
    fontSize: size.text3
  },
  textHeaderKanitMediumFakeBlack: {
    ...textStyles.h2,
    fontSize: size.text18,
    color: Colors.font.primary.fakeBlack
  },
  textMessage: {
    ...textStyles.body2,
    fontSize: size.content,
    color: Colors.font.primary.darkGray
  },
  textcontent: {
    fontFamily: type.Kanit,
    fontSize: size.content,
    color: Colors.font.primary.darkGray
  },
  textcontentKanitRegular: {
    ...textStyles.subtitle2,
    fontSize: size.content,
    color: Colors.font.primary.darkGray
  },
  textcontentKanitRegularDarkpuple: {
    fontFamily: type.KanitRegular,
    fontSize: size.content,
    color: Colors.darkPurple
  },
  textContentMedium: {
    fontFamily: type.Kanit,
    fontSize: size.text16,
    color: Colors.font.primary.darkGray
  },
  textContentMediumBold: {
    fontFamily: type.KanitBold,
    fontSize: size.text16,
    color: Colors.font.primary.darkGray
  },
  textButton: {
    fontFamily: type.Kanit,
    fontSize: size.text24,
    color: Colors.white,
    textAlign: 'center'
  },
  textTopMenu: {
    ...textStyles.body2,
    color: Colors.white
  },
  textDescription: {
    ...textStyles.subtitle2,
    fontSize: size.content,
    color: '#111111'
  },
  textHeaderKanitRegular16: {
    fontFamily: type.KanitRegular,
    fontSize: size.text16,
  },
  textHeaderKanitRegular14: {
    fontFamily: type.KanitRegular,
    fontSize: size.text14,
  },
  modalConfirmButtonTextRegular: {
    fontFamily: type.KanitRegular,
    fontSize: size.text14,
  },
  textHeaderKanitSemiBold20: {
    fontFamily: type.KanitSemiBold,
    fontSize: size.text3,
  },
  textDescriptionKanitLight12: {
    fontFamily: type.KanitLight,
    fontSize: size.text12,
  },
  textBodyRegularFakeBlack14: {
    ...textStyles.subtitle2,
    fontSize: size.text14,
    color: Colors.font.primary.fakeBlack
  },
  textBodyRegularGray12: {
    ...textStyles.subtitle2,
    fontSize: size.text12,
    color: Colors.font.primary.gray
  }
};
export default {
  type,
  size,
  style
};
